﻿const sortUrl = '/api/sortable/sort';
const addFileUrl = '/api/files/link';
const removeFileUrl = '/api/files/unlink';

export function sortFiles(elementType, elementId) {
	let data = new FormData();
	data.append('elementType', elementType)
	data.append('elementId', elementId)
	return fetch(sortUrl, {
		method: 'POST',
		body: new URLSearchParams(data)
	});
}

export function addFile(elementType, elementId, fileId) {
	let data = new FormData();
	data.append('elementType', elementType)
	data.append('elementId', elementId)
	data.append('fileId', fileId)
	return fetch(addFileUrl, {
		method: 'POST',
		body: new URLSearchParams(data)
	});
}

export function removeFile(elementType, elementId, fileId) {
	let data = new FormData();
	data.append('elementType', elementType)
	data.append('elementId', elementId)
	data.append('fileId', fileId)
	return fetch(removeFileUrl, {
		method: 'POST',
		body: new URLSearchParams(data)
	});
}